import React from 'react';
import { useNavigate } from 'react-router-dom';

const Layout = ({ children, activeNav, onNavChange }) => {
  const navigate = useNavigate();
  
  const navItems = [
    { id: 'dashboard', label: 'Dashboard', icon: '📊', path: '/' },
    { id: 'products', label: 'Product Master', icon: '📦', path: '/products' },
    { id: 'inward', label: 'Inward Management', icon: '📥', path: '/inward' },
    { id: 'outward', label: 'Outward Management', icon: '📤', path: '/outward' },
    { id: 'returns', label: 'Returns Management', icon: '↩️', path: '/returns' },
    { id: 'putaway', label: 'Putaway Management', icon: '🏠', path: '/putaway' },
    { id: 'bins', label: 'Bin Management', icon: '📍', path: '/bins' },
    { id: 'reports', label: 'Reports', icon: '📈', path: '/reports' },
  ];

  const handleNavClick = (item) => {
    onNavChange(item.id);
    navigate(item.path);
  };

  return (
    <div className="flex h-screen w-screen bg-gray-50 overflow-hidden">
      {/* Sidebar */}
      <div className="w-64 bg-white border-r border-gray-200 shadow-sm flex flex-col flex-shrink-0">
        {/* Logo */}
        <div className="p-6 border-b border-gray-200 flex-shrink-0">
          <h1 className="text-2xl font-bold text-primary">JustDeliveries</h1>
          <p className="text-xs text-gray-500 mt-1">WMS Portal</p>
        </div>

        {/* Navigation */}
        <nav className="flex-1 p-4 space-y-2 overflow-y-auto">
          {navItems.map(item => (
            <button
              key={item.id}
              onClick={() => handleNavClick(item)}
              className={`w-full flex items-center gap-3 px-4 py-3 rounded-lg text-sm font-medium transition-colors ${
                activeNav === item.id
                  ? 'bg-green-50 text-green-700 border-l-4 border-green-500'
                  : 'text-gray-600 hover:bg-gray-100'
              }`}
            >
              <span>{item.icon}</span>
              <span>{item.label}</span>
            </button>
          ))}
        </nav>

        {/* Logout */}
        <div className="p-4 border-t border-gray-200 flex-shrink-0">
          <button className="w-full flex items-center justify-center gap-2 px-4 py-2 text-green-600 border border-green-600 rounded-lg hover:bg-green-50 font-medium text-sm transition-colors">
            <span>🚪</span>
            Logout
          </button>
        </div>
      </div>

      {/* Main Content */}
      <div className="flex-1 flex flex-col overflow-hidden">
        {/* Header */}
        <div className="bg-white border-b border-gray-200 px-8 py-4 flex justify-between items-center shadow-sm flex-shrink-0">
          <h2 className="text-gray-600 text-sm">
            <span className="text-gray-400">WMS Portal</span>
          </h2>
          <div className="flex items-center gap-4">
            <div className="w-8 h-8 bg-gradient-to-br from-blue-400 to-blue-600 rounded-full flex items-center justify-center text-white text-sm font-semibold">
              U
            </div>
            <div>
              <p className="text-sm font-medium text-gray-700">User</p>
              <p className="text-xs text-gray-500">Admin Account</p>
            </div>
          </div>
        </div>

        {/* Page Content */}
        <div className="flex-1 overflow-y-auto p-8 bg-gray-50">
          {children}
        </div>
      </div>
    </div>
  );
};

export default Layout;
